import { useEffect } from 'react'

const QRMemoryIndividual = ({ payload, data, isActiveWomensMode }) => {

    const LoadPage = async () => {
        try {
            document.getElementById("root").classList.add("BodyComplete")
        } catch (error) {

        }
    }

    useEffect(() => {
        LoadPage()
    }, [])

    return (
        <>
            <div className='SelfieFan__Screen__QR__Background'>
                {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='SelfieFan__Screen__Selfie__Background__Image' alt="Fondo Femenil" />
                ) : (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png' className='SelfieFan__Screen__Selfie__Background__Image' alt="Fondo Varonil" />
                )}
            </div>

            <div className='SelfieFan__Screen__QR__Box SelfieFan__Screen__QR__Up'>
                <div className='SelfieFan__Screen__QR__Container'>
                    <div className='SelfieFan__Screen__QR__Container__Instructions'>
                        <img src="/img/page/adsl-five.png" className="Screen__Welcome__Container__Info__Image" alt="Logo ADSL" />
                        <p className='SelfieFan__Screen__QR__Container__Instructions__Text' style={{ fontFamily: '"GFS Didot", serif' }}>ESCANEA EL CÓDIGO Y JUEGA CON NOSOTROS</p>
                    </div>

                    <img src='/img/page/qr/memorama-individual-qr-fondo-gris-sin-parametros.png' className='SelfieFan__Screen__QR__Container__QR' alt="Código QR Memorama Individual" />
                </div>
            </div>

            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>Hecho con ♥ por Interaktia</footer>
        </>
    )
}

export { QRMemoryIndividual }
export default QRMemoryIndividual
